import React, { useEffect, useState } from "react";
import styles from "./RecomendationPage.module.css";
import recomendationLogo from "../../../assets/Imagess/audRecomendationLogo.png";
import CustomizedSelect from "../../Atoms/Inputs/CustomizedSelect";
import DocumentUpload from "../../Atoms/Documents/DocumentUpload";
import TextInput from "../../Atoms/Inputs/TextInput";
import Buttons from "../../Atoms/Buttons/Buttons";
import { Formik, Form, useFormik, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  useFEtchReferenceById,
  useFetchDropDownbyType,
  usePostFormReferance,
  usePostReferance,
} from "../../../Hooks/Recomendation";
import { toast } from "react-toastify";
import LoaderButton from "../../Moecules/Loader/LoaderButton";
import Loader from "../../Moecules/Loader/Loader";
import RadioButtonGroup from "../../Atoms/Inputs/RadioButtons/RadioButtonGroup";
import getValidationSchema from "./ValidationSchema";
import FillRecomendationForm from "./FillRecomendationForm";

const radioOptions = [
  { label: "Upload", value: true },
  { label: "Fill-up Recommendation Form", value: false },
];
const RecomemdationPage = ({ setIsSuccess }) => {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let referenceId = params.get("ReferenceId");
  const {
    data: referenceByIdData,
    refetch: refetchReferenceData,
    isLoading: isReferenceDAtaLoading,
  } = useFEtchReferenceById(referenceId);
  const { mutate: postReferance, isLoading: isPostLoading } =
    usePostReferance();
  const { mutate: poatFormReference, isLoading: isPostFormLoading } =
    usePostFormReferance();
  const { data: dropDownTypeData } = useFetchDropDownbyType("1");
  const [init, setInit] = useState({});
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
  useEffect(() => {
    setInit({
      title: referenceByIdData?.data
        ? referenceByIdData?.data[0]?.referanceTitle
        : "",
      fullName: referenceByIdData?.data
        ? referenceByIdData?.data[0]?.referanceName
        : "",
      email: referenceByIdData?.data
        ? referenceByIdData?.data[0]?.referanceEmail
        : "",
      documentUpload: "",
      formType: "",
      howLongYouKnowAdmin: "",
      context: "",
      personalityText: "",
      additionalComments: "",
      evaluatorName: "",
      titlePosition: "",
      company: "",
      otherContext: "",
      intellectualAbility: "",
      analyticalAbility: "",
      leadershipPotential: "",
      teamworkSkills: "",
      planningSkills: "",
      communicationSkills: "",
      overall: "",
    });
  }, [referenceByIdData]);

  const handleReferencePost = (values) => {
    const formData = new FormData();
    formData.append("ApplicantReferanceId", referenceId);
    formData.append("ReferanceFile", values.documentUpload);
    postReferance(formData, {
      onSuccess: () => {
        toast.success("Submitted Successfully");
        setIsSuccess(true);
      },
      onError: () => {
        toast.error("Something went wrong");
      },
    });
  };
  const handleReferenceFormPost = (values) => {
    const data = {
      referenceId: referenceId,
      applicantId: referenceByIdData?.data?.[0]?.applicantId,
      applicationId: referenceByIdData?.data?.[0]?.applicationId,
      knowApplicant: values.howLongYouKnowAdmin,
      knowContext: values.context,
      otherContext: values.otherContext,
      intellectualAbility: values.intellectualAbility,
      analyticalAbility: values.analyticalAbility,
      leadershipPotential: values.leadershipPotential,
      teamworkSkills: values.teamworkSkills,
      planningSkills: values.planningSkills,
      communicationSkills: values.communicationSkills,
      overall: values.analyticalAbility,
      behaviorTraits: values.personalityText,
      additionalComments: values.additionalComments,
      evaluatorName: values.evaluatorName,
      title: values.titlePosition,
      company: values.company,
      dateSubmitted: new Date(),
    };
    poatFormReference(data, {
      onSuccess: () => {
        toast.success("Submitted Successfully");
        setIsSuccess(true);
      },
      onError: () => {
        toast.error("Something went wrong");
      },
    });
  };

  const formattedOptions = dropDownTypeData?.data
    ? dropDownTypeData?.data?.map((option) => ({
        value: option.ddid,
        text: option.text,
      }))
    : [];
  const formik = useFormik({
    initialValues: init,
    validationSchema: getValidationSchema(),
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsSubmitAttempted(false);
      if (values.formType) {
        handleReferencePost(values);
      } else {
        handleReferenceFormPost(values);
      }
    },
  });

  useEffect(() => {
    if (isSubmitAttempted && Object.keys(formik.errors)?.length > 0) {
      toast.error("Please fill all required fields");
    }
    setTimeout(() => {
      setIsSubmitAttempted(false);
    }, 500);
  }, [formik.errors, isSubmitAttempted]);

  const handleSubmit = () => {
    setIsSubmitAttempted(true);
    formik.handleSubmit();
  };

  if (isReferenceDAtaLoading) return <Loader />;

  return (
    <FormikProvider value={formik}>
      <div
        className={`${styles["recomendation-subContainer"]} ${styles["scroll"]}`}
      >
        <h2>
          <span>
            {referenceByIdData?.data[0]?.applicantFirstName}{" "}
            {referenceByIdData?.data[0]?.applicantLastName}
          </span>{" "}
          has requested a letter of recommendation from you to support{" "}
          <span>{referenceByIdData?.data[0]?.applicantFirstName}'s</span>{" "}
          application for the graduate program at the American University in
          Dubai. 
        </h2>
        <div className={styles["text-cont"]}>
          <CustomizedSelect
            label='Title'
            options={formattedOptions}
            grey={true}
            name='title'
            value={formik.values.title}
            text={true}
            onChange={(name, value) => {
              formik.setFieldValue(name, value);
            }}
            errors={formik.errors.title}
            touched={formik.touched.title}
            disabled
          />
          <TextInput
            label='Full Name'
            grey={true}
            name='fullName'
            value={formik.values.fullName}
            // text={true}
            onChange={(name, value) => {
              formik.setFieldValue(name, value);
            }}
            errors={formik.errors.fullName}
            touched={formik.touched.fullName}
            disabled
          />
        </div>
        <TextInput
          label='Email'
          name='email'
          grey={true}
          value={formik.values.email}
          // text={true}
          onChange={(name, value) => {
            formik.setFieldValue(name, value);
          }}
          errors={formik.errors.email}
          touched={formik.touched.email}
          disabled
        />
        <RadioButtonGroup
          options={radioOptions}
          selectedValue={formik.values.formType}
          onRadioChange={(name, value) => {
            formik.setFieldValue(name, value);
          }}
          name='formType'
          errors={formik.errors.formType}
          touched={formik.touched.formType}
        />
        {formik.errors?.formType && (
          <p className={styles.errorMessage}>{formik.errors.formType}</p>
        )}

        {formik.values?.formType === true && (
          <DocumentUpload
            text='Upload Letter of Recommendation'
            name='documentUpload'
            value={formik.values.documentUpload}
            onChange={(name, value) => {
              formik.setFieldValue(name, value);
            }}
            errors={formik.errors.documentUpload}
            touched={formik.touched.documentUpload}
          />
        )}
        {formik.values?.formType === false && <FillRecomendationForm />}

        {isPostLoading ? (
          <LoaderButton />
        ) : (
          <Buttons text='Submit' type='button' handleOnClick={handleSubmit} />
        )}
      </div>
    </FormikProvider>
  );
};

export default RecomemdationPage;
